import { GetRetailRateRequestsResponse } from '@classpass/protobuf-definitions/lib/web/grpc/partners/retail_rate_requests';

import URLS from 'constants/urls';
import { httpClient } from 'helpers/http';

export const getClassIdFromRetailRateRequest = (request = {}) => request.classId ?? request.class_id ?? null;

export const getCreatedAtMs = (request = {}) => {
  const createdAt = request.createdAt ?? request.created_at;

  if (!createdAt) {
    return 0;
  }

  if (typeof createdAt.getTime === 'function') {
    return createdAt.getTime();
  }

  const parsed = new Date(createdAt).getTime();

  return Number.isNaN(parsed) ? 0 : parsed;
};

// Venue RRR responses include request history; list rows need the current request per class.
export function latestRequestPerClassId(requests = []) {
  const byClassId = new Map();

  requests.forEach(request => {
    const classId = getClassIdFromRetailRateRequest(request);

    if (classId === null || classId === undefined || classId === '') {
      return;
    }

    const key = String(classId);
    const current = byClassId.get(key);

    if (!current || getCreatedAtMs(request) > getCreatedAtMs(current)) {
      byClassId.set(key, request);
    }
  });

  return byClassId;
}

export function mergeRetailRateRequestsByClassId(rows = [], requests = []) {
  const latestByClassId = latestRequestPerClassId(requests);

  return rows.map(row => {
    const classId = row?.classId ?? row?.class_id;

    if (classId === null || classId === undefined || classId === '') {
      return row;
    }

    const retailRateRequest = latestByClassId.get(String(classId));

    if (!retailRateRequest) {
      return row;
    }

    return {
      ...row,
      retailRateRequest,
    };
  });
}

export async function fetchRetailRateRequestsByVenue(venueId) {
  const response = await httpClient.get(URLS.manageServices.services.retailRateRequestsByVenue(venueId));
  const { retailRateRequest = [] } = GetRetailRateRequestsResponse.fromJSON(response.data);

  return retailRateRequest;
}
